import * as React from "react";
const Industrymain = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6665 4.14551C13.0472 4.14551 14.1665 5.2648 14.1665 6.64551L14.1666 7.62107C14.4272 7.52896 14.7077 7.47884 14.9998 7.47884H18.3332C19.7139 7.47884 20.8332 8.59813 20.8332 9.97884V18.3122C20.8332 19.6929 19.7139 20.8122 18.3332 20.8122H6.6665C5.28579 20.8122 4.1665 19.6929 4.1665 18.3122V6.64551C4.1665 5.2648 5.28579 4.14551 6.6665 4.14551H11.6665ZM11.6665 5.81217H6.6665C6.20627 5.81217 5.83317 6.18527 5.83317 6.64551V18.3122C5.83317 18.7724 6.20627 19.1455 6.6665 19.1455H12.4998V6.64551C12.4998 6.18527 12.1267 5.81217 11.6665 5.81217ZM18.3332 9.14551H14.9998C14.5396 9.14551 14.1665 9.5186 14.1665 9.97884V19.1455H18.3332C18.7934 19.1455 19.1665 18.7724 19.1665 18.3122V9.97884C19.1665 9.5186 18.7934 9.14551 18.3332 9.14551ZM9.99984 14.1455C10.4601 14.1455 10.8332 14.5186 10.8332 14.9788C10.8332 15.4391 10.4601 15.8122 9.99984 15.8122H8.33317C7.87293 15.8122 7.49984 15.4391 7.49984 14.9788C7.49984 14.5186 7.87293 14.1455 8.33317 14.1455H9.99984ZM17.4998 14.1455C17.9601 14.1455 18.3332 14.5186 18.3332 14.9788C18.3332 15.4391 17.9601 15.8122 17.4998 15.8122H15.8332C15.3729 15.8122 14.9998 15.4391 14.9998 14.9788C14.9998 14.5186 15.3729 14.1455 15.8332 14.1455H17.4998ZM9.99984 10.8122C10.4601 10.8122 10.8332 11.1853 10.8332 11.6455C10.8332 12.1057 10.4601 12.4788 9.99984 12.4788H8.33317C7.87293 12.4788 7.49984 12.1057 7.49984 11.6455C7.49984 11.1853 7.87293 10.8122 8.33317 10.8122H9.99984ZM17.4998 10.8122C17.9601 10.8122 18.3332 11.1853 18.3332 11.6455C18.3332 12.1057 17.9601 12.4788 17.4998 12.4788H15.8332C15.3729 12.4788 14.9998 12.1057 14.9998 11.6455C14.9998 11.1853 15.3729 10.8122 15.8332 10.8122H17.4998ZM9.99984 7.47884C10.4601 7.47884 10.8332 7.85194 10.8332 8.31217C10.8332 8.77241 10.4601 9.14551 9.99984 9.14551H8.33317C7.87293 9.14551 7.49984 8.77241 7.49984 8.31217C7.49984 7.85194 7.87293 7.47884 8.33317 7.47884H9.99984Z"
      fill="url(#paint0_linear_1_51486)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_51486"
        x1={12.4998}
        y1={4.14551}
        x2={12.4998}
        y2={20.8122}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1AB3FF" />
        <stop offset={1} stopColor="#FFB258" />
      </linearGradient>
    </defs>
  </svg>
);
export default Industrymain;
